import request, { type CustomizeConfigType } from '@/utils/request';
import { stringifySearchParams } from '@/utils/url';
import axios from 'axios';

const ajaxCache = {};

function apiFactory(serviceName: string, methods: string[]) {
  type ServiceType = {
    [key: string]: (data?: any, config?: CustomizeConfigType) => Promise<any> & { abort: Function };
  };
  const serviceObject: ServiceType = methods.reduce((service, method) => {
    service[method] = (data: any, config?: CustomizeConfigType) => {
      const customizeConfig: CustomizeConfigType = Object.assign({
        throwError: true,
      }, config ?? {});
      const api = data?.api;
      let action = `/${serviceName}/${method}`;
      if (['/App/ajaxProcess'].includes(action)
        && !data?.jsondata
        && data?.form
      ) {
        try {
          const jsonFormData = JSON.stringify(data.form);
          if (jsonFormData != '{}') {
            data.form = jsonFormData;
            data.jsondata = true;
          }
        } catch { }
      }
      if (api) {
        action += '?api=' + encodeURIComponent(api);
      }
      let requestParams = {
        method: 'post',
        url: action,
        responseType: 'json',
        data: data instanceof FormData
          ? data
          : stringifySearchParams(data),
        __customizeConfig: customizeConfig,
      } as any;

      if (customizeConfig.getAbort) {
        const source = axios.CancelToken.source();
        requestParams.cancelToken = source.token;
        customizeConfig.getAbort(source.cancel);
      }

      // 缓存支持
      if (config?.cache) {
        const catheKey = [
          config.cache == 'route'
            ? window.location.href
            : null,
          serviceName, method, JSON.stringify(data)
        ].filter(Boolean).join('_');
        const cache = ajaxCache[catheKey];
        if (cache) {
          return cache;
        } else {
          return ajaxCache[catheKey] = request(requestParams)
            .catch(() => delete ajaxCache[catheKey]);
        }
      }
      return request(requestParams);
    };
    return service;
  }, {});
  return serviceObject;
}

export default apiFactory;
